import React, { useEffect, useMemo, useState } from 'react';
import block from 'bem-cn';
import PT from 'prop-types';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

import { getTimer } from 'shared/helpers/getTimer';

import './BithidePaymentInfoPending.scss';

const b = block('bithide-payment-info-pending');

const BithidePaymentInfoPending = ({ getDepositInfo }) => {
  const { locale } = useSelector(state => state.locale);
  const {
    depositInfo: {
      replenishmentAddress,
      fromCurrency,
      fromCurrencyAmount,
      validUntil,
    },
  } = useSelector(state => state.payment);

  const [timer, setTimer] = useState('0:00');
  
  const validDate = useMemo(() => dayjs(validUntil), [validUntil]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(getTimer(validDate));
    }, 1000);
    return () => clearInterval(interval);
  }, [validDate, timer]);

  useEffect(() => {
    const interval = setInterval(() => {
      getDepositInfo();
    }, 30000);
    return () => clearInterval(interval);
  }, [getDepositInfo]);

  return (<>
    <div className={b('field')}>
      <p className={b('label')}>
        {locale.addressForReplenishment}
      </p>
      <div className={b('input')}>
        <p className={b('value')}>{replenishmentAddress}</p>
      </div>
    </div>

    <div className={b('field')}>
      <p className={b('label')}>
        {locale.network}
      </p>
      <div className={b('input')}>
        <p className={b('value')}>{fromCurrency}</p>
      </div>
    </div>

    <div className={b('field')}>
      <p className={b('label')}>
        {locale.enterThePaymentPurchase}
      </p>
      <div className={b('input')}>
        <p className={b('value')}>{Number(fromCurrencyAmount).toFixed(2)}</p>
        <p className='measure'>USDT</p>
      </div>
    </div>

    <p className={b('description')}>
      {locale.weAreWaitingForThePaymentToArriveDescription}
    </p>

    <div className={b('timer')}>
      <p className={b('timer-text')}>
        {locale.weAreWaitingForThePaymentToArrive}
      </p>
      <p className={b('timer-value')}>{timer}</p>
    </div>
  </>);
};

BithidePaymentInfoPending.propTypes = {
  getDepositInfo: PT.func,
};

export default BithidePaymentInfoPending;
